import { render } from "./ProductEdit.vue?vue&type=template&id=bc157a00&scoped=true"
import script from "./ProductEdit.js?vue&type=script&lang=js&external"
export * from "./ProductEdit.js?vue&type=script&lang=js&external"

import "./ProductEdit.scss?vue&type=style&index=0&id=bc157a00&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc157a00"]])

export default __exports__